import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

import { multiChangeFormFields } from '@eventbrite/redux-form-tools';

import { transformApiImageToImageField } from './transformApiImageToImageField';

// exported for testing
export const makeCropMaskFromValues = (x, y, width, height) => {
    if ((x || x === 0) && (y || y === 0) && width && height) {
        return { x, y, width, height };
    }

    return null;
};

// exported for testing
export const mapStateToProps = (state, fieldName, getFieldValue) => ({
    name: fieldName,
    imageId: getFieldValue(state, fieldName),
    originalUrl: getFieldValue(state, `${fieldName}OriginalUrl`),

    cropMask: makeCropMaskFromValues(
        getFieldValue(state, `${fieldName}CropX`),
        getFieldValue(state, `${fieldName}CropY`),
        getFieldValue(state, `${fieldName}CropWidth`),
        getFieldValue(state, `${fieldName}CropHeight`),
    ),
});

// exported for testing
export const mapDispatchToProps = (dispatch, formName, fieldName) => ({
    updateFieldsFromObject: (apiImage) => {
        multiChangeFormFields(
            dispatch,
            formName,
            transformApiImageToImageField(fieldName, apiImage),
        );
    },
});

/**
 * Connects an EDS ImageField component to redux-form state
 * @param {ReactComponent} ImageFieldComponent Reference to EDS ImageField component
 * @param {string} formName Name of the form
 * @param {string} fieldName Form field name
 * @returns {ReactComponent} Connected ImageField component
 */
export const connectImageField = (ImageFieldComponent, formName, fieldName) => {
    const getFieldValue = formValueSelector(formName);

    return connect(
        (state) => mapStateToProps(state, fieldName, getFieldValue),
        (dispatch) => mapDispatchToProps(dispatch, formName, fieldName),
    )(ImageFieldComponent);
};
